__turbopack_context__.v({
  "host": "Slots-module-scss-module__IY9wrq__host",
  "hosts": "Slots-module-scss-module__IY9wrq__hosts",
  "slotItem": "Slots-module-scss-module__IY9wrq__slotItem",
  "slots": "Slots-module-scss-module__IY9wrq__slots",
  "text": "Slots-module-scss-module__IY9wrq__text",
  "title": "Slots-module-scss-module__IY9wrq__title",
});
